import React, { useContext } from "react";
import clsx from "clsx";
import makeStyles from "@material-ui/styles/makeStyles";
import ReactAnimation from "@micado-digital/react-animation/ReactAnimation";
import ReactSVGIcon from "@micado-digital/react-svg-icon/ReactSVGIcon";
import Header from "../../components/header";
import Footer from "../../components/footer";
import PageContext from "@PageContext";
import ContentElements from "./contentElements";
import AnimationTeaser from "./animationTeaser";

// calculate vh (viewport height) for mobile devices

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

const useStyles = makeStyles((theme) => ({
	root: {
		position: "relative"
	},
	animationWrapperIntro: {
		height: "max(350px, calc(var(--vh, 1vh) * 100))"
	},
	animationWrapper: {
		height: "max(350px, calc(var(--vh, 1vh) * 75))",
		paddingTop: 64,
		[theme.breakpoints.up("lg")]: {
			paddingTop: 96
		},
		"& img": {
			objectPosition: "top"
		}
	}
}));

const LayoutStandard = ({ variant }) => {
	const { REACT_APP_PATH } = process.env;
	const [pageData] = useContext(PageContext);
	const css = useStyles();
	const teaserURL = REACT_APP_PATH + "/teaser.json.api?groupID=18&format=v2";

	const footerAddresses = [
		{
			id: 1,
			title: "Wirtschaftsleitung Altenwohnheime",
			// street: "Werner Mair BEd",
			phone: "+43 5372 602 700",
			mail01: "wirtschaftsleitung@stadt.kufstein.at"
		},
		{
			id: 2,
			title: "AWH Innpark",
			street: "Saluner Straße 38b",
			phone: "+43 5372 602-770",
			mail01: "altenwohnheim@stadt.kufstein.at"
		},
		{
			id: 3,
			title: "AWH Zell",
			street: "Lindenallee 2",
			phone: "+43 5372 602-700",
			mail01: "altenwohnheim@stadt.kufstein.at"
		}
	];

	if (variant) {
		document.body.classList.add(variant);
	}

	let mediaFormats = null;

	if (pageData?.animationID && variant === "intro") {
		mediaFormats = { xs: "animation-mobile", sm: "animation" };
	} else {
		mediaFormats = { xs: "animation-small-mobile", sm: "animation-small" };
	}

	return (
		<>
			<Header />
			{pageData?.animationID && variant !== "noanimation" && (
				<div
					className={clsx(
						"container-animation",
						css.root,
						pageData?.animationID && variant === "intro"
							? css.animationWrapperIntro
							: css.animationWrapper
					)}
				>
					<ReactAnimation
						api={`${REACT_APP_PATH}/animationV3.json.api`}
						id={pageData?.animationID}
						mediaFormats={mediaFormats}
						prevIcon={<ReactSVGIcon src="/img/icons/chevron-left.svg" size={24} />}
						nextIcon={<ReactSVGIcon src="/img/icons/chevron-right.svg" size={24} />}
						showArrows
						showBullets
						webpFallback
					/>
					{pageData?.animationID && variant !== "noanimation" ? (
						<AnimationTeaser teaserURL={teaserURL}></AnimationTeaser>
					) : (
						<></>
					)}
				</div>
			)}
			<main>
				<ContentElements />
			</main>
			<Footer addresses={footerAddresses} />
		</>
	);
};

export default LayoutStandard;
